import { TextInput as RaTextInput } from 'react-admin';
import { styled } from '@mui/material';

const IdInput = styled(RaTextInput)({
  minWidth: '16rem',
});

export default IdInput;
